import type { BasePaginationDto } from '@@types/api.types';
import { AdminPagination } from '@components/ui/admin-pagination';
import React from 'react';

type AdminCategoriesPaginationProps = {
  isFetching?: boolean;
  onLimitChange: (limit: number) => void;
  onNextPage: () => void;
  onPreviousPage: () => void;
  pagination: BasePaginationDto;
};

export const AdminCategoriesPagination: React.FC<AdminCategoriesPaginationProps> = (props) => {
  const { isFetching, onLimitChange, onNextPage, onPreviousPage, pagination } = props;

  return (
    <AdminPagination
      isFetching={isFetching}
      itemLabel="categories"
      onLimitChange={onLimitChange}
      onNextPage={onNextPage}
      onPreviousPage={onPreviousPage}
      pagination={pagination}
    />
  );
};
